{
  "retry": "Retry",
  "cancel": "Cancel",
  "error": "Error",
  "noItemsFound": "No items found.",
  "showDetails": "Show technical details",
  "hideDetails": "Hide technical details",
  "darkMode": "Dark mode",
  "dateRange": "Date range",
  "selectDateRange": "Select date range",
  "toggleFullscreen": "Toggle fullscreen",
  "myDashboards": "My Dashboards",
  "hideSidebar": "Hide Sidebar",
  "showSidebar": "Show Sidebar",
  "filterRows": "Filter rows...",
  "noRecordsToDisplay": "No records to display",
  "noMatchingRows": "No matching rows",
  "tryDifferentSearchTerm": "Try a different search term",
  "clearSelection": "Clear selection",
  "askAboutSelected": "Ask about selected",
  "addAsAttachment": "Add as attachment",
  "compareSelected": "Compare selected",
  "collapseRow": "Collapse row",
  "noDataAvailableForChart": "No data available for chart"
}
